import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components/macro';

import data from './data';
import { viewport } from '../../../common/config';
import PreviewHeading from '../../../components/PreviewHeading';
import { Title, Subtitle } from '../styled';
import useAnimation from './useAnimation';

const Wrapper = styled.div`
  cursor: pointer;
  display: none;

  @media screen and (min-width: ${viewport.md}) {
    display: block;
  }
`;

const PreviewContent = ({ index, incrementIndex }: {
  index: number,
  incrementIndex: () => void
}) => {
  const title = useRef<HTMLHeadingElement>(null);
  const subtitle = useRef<HTMLHeadingElement>(null);

  const [localIndex, setLocalIndex] = useState(index);

  const [fadeout, fadein] = useAnimation([title, subtitle]);

  useEffect(() => {
    fadeout.current?.play(0).eventCallback("onComplete", () => {
      setLocalIndex(index);
      fadein.current?.play(0);
    });
  }, [index]);

  return (
    <Wrapper onClick={incrementIndex}>
      <PreviewHeading />

      <Title ref={title}>{data[localIndex].title}</Title>
      <Subtitle ref={subtitle}>{data[localIndex].subtitle}</Subtitle>
    </Wrapper>
  );
}

export default PreviewContent;